import classes from "./UnitPrice.module.scss";
import React from "react";
import DiscountPlan from "@r6digital/rapidstor-types/types/DiscountPlan";
import UnitType from "../../features/rapidstor/entities/UnitType";

interface Props extends React.HTMLAttributes<HTMLElement> {
  unitType: UnitType;
}

function getDiscountLabel(discountPlan?: DiscountPlan): string | undefined {
  if (!discountPlan) {
    return undefined;
  }

  let text = "";

  if (discountPlan.dcPCDiscount) {
    text = `Save ${Math.floor(discountPlan.dcPCDiscount)}%`;
  } else if (discountPlan.dcFixedDiscount) {
    text = `Save $${discountPlan.dcFixedDiscount.toFixed(2)}`;
  }

  if (discountPlan.iExpirMonths) {
    if (text === "") {
      text = "Discount applies";
    }
    if (discountPlan.iExpirMonths === 1) {
      text += ` for first month`;
    } else {
      text += ` for ${discountPlan.iExpirMonths} months`;
    }
  }

  return text;
}

export default function UnitPrice({ unitType }: Props) {
  return (
    <div className="text-end">
      {unitType.rates.discountedRate !== unitType.rates.rate && (
        <>
          <div className={`${classes.listPrice}`}>
            List Price:{" "}
            <span className={`text-decoration-line-through text-primary fw-semibold`}>
              ${unitType.rates.rate.toFixed(2)}
            </span>
          </div>
          <div className={`${classes.listPrice}`}>
            {getDiscountLabel(unitType.deal?.discountPlan)}
          </div>
        </>
      )}
      <div className={`${classes.rate} mb-1`}>
        <span className={`${classes.rateNumber} text-primary fw-semibold`}>
          ${unitType.rates.discountedRate.toFixed(2)}
        </span>{" "}
        / month
      </div>
    </div>
  );
}
